import React from 'react';
import '../styles.css';
import AppBar from '../components/AppBar.js';
import LevelSelectDescription from '../components/levelSelect/LevelSelectDescription.js';
import SubLevelSelectGrid from '../components/levelSelect/SubLevelSelectGrid';
import { Link } from 'react-router-dom'

function SubLevelSelect(props) {
    return (
        <div>
            <AppBar name='' displayText='Level Select' backTo='Level Select' />
            <div className='column' style={{ marginTop: 100 }}>
                <LevelSelectDescription text={props.level.toUpperCase()}/>
                <SubLevelSelectGrid level={props.level}/>
            </div>
        </div>
    );
}

export default SubLevelSelect
